// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__3VT01","logo":"Navbar_logo__1nFMD","select":"Navbar_select__2FWiG"};